export const truncateWithEllipsis = (string: string, maxLength: number) => {
  if (string.length < maxLength) {
    return string
  }

  return string
    .trim()
    .substring(0, maxLength)
    .padEnd(maxLength + 3, '...')
}
